import { Injectable } from '@angular/core';
import { InsightsUtility } from '@utilities/insights/insights.utility';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class LexbeThemeService {
	public isDarkMode$: BehaviorSubject<boolean>;
	constructor(private insightsUtility: InsightsUtility,) {
		let isDarkMode = localStorage['darkMode'] === 'true';
		this.isDarkMode$ = new BehaviorSubject(isDarkMode);

		fromEvent<StorageEvent>(window, 'storage').pipe(
			filter(event => event.storageArea === localStorage && event.key === "darkMode")
		).subscribe(() => {
			isDarkMode = localStorage['darkMode'] === 'true';
			this.isDarkMode$.next(isDarkMode);
		});
	}

	public isDarkMode(): boolean {
		this.isDarkMode$.next(localStorage['darkMode'] === 'true');
		return this.isDarkMode$.value;
	}

	public setLocalStorage(isDarkMode: boolean) {
		localStorage.setItem('darkMode', isDarkMode.toString());
		this.isDarkMode$.next(isDarkMode);
		const themeSetting: 'light-theme' | 'dark-theme' = isDarkMode ? 'dark-theme' : 'light-theme';
		this.insightsUtility.updateTelemetryContext({
			themeSetting: themeSetting
		});
	}
}
